import * as React from 'react';
import InfoDialog, {InfoDialogProps, InfoDialogVariants} from 'cl-dialogs/InfoDialog';
import InlineButton from '../../InlineButton';
import {contactSupportWithMessage} from '../../../helpers/analyticsHelper';
import {clearAddAmazonAccountError} from '../../../../MyAccount/ViewDesigns/redux/modules/accountPage';
import connectWithRouter from '../../redux/connectWithRouter';

export interface AmazonAccountErrorDialogProps extends InfoDialogProps {
  clearAddAmazonAccountError: typeof clearAddAmazonAccountError;
}

function AmazonAccountErrorDialog(props: AmazonAccountErrorDialogProps) {
  const {message, open} = props;

  const clearErrorAndCloseDialog = () => {
    const {onClose, clearAddAmazonAccountError} = props;
    onClose(null);
    clearAddAmazonAccountError();
  };

  return (
    <InfoDialog
      onClose={clearErrorAndCloseDialog}
      title={'Adding an Amazon account has encountered a problem'}
      open={open && !!message}
      variant={InfoDialogVariants.Error}
      instructionText={{
        before: 'The following error has occurred:',
        after: (
          <React.Fragment>
            If you don’t know how to fix this you may{' '}
            <InlineButton
              onClick={() =>
                contactSupportWithMessage(
                  `I got a problem with adding my amazon seller, and received this error: ${message}, what should I do?`
                )
              }
            >
              ask for help
            </InlineButton>{' '}
            from CrazyLister’s team. We are always happy to help.
          </React.Fragment>
        ),
      }}
      message={message}
    />
  );
}

export default connectWithRouter(() => {}, {clearAddAmazonAccountError})(AmazonAccountErrorDialog);
